module.exports = " <div class=downloadwrap :class=\"{'zIndex':show}\"> <div class=downloadbox> <img class=logo :src=info.logo alt=\"\"> <div> <pre>{{info.content}}</pre> </div> <a @click=download(info.url)>下载</a> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/Download.vue
// module id = 144
// module chunks = 0